import { initializeApp, getApps } from 'firebase/app';
import { getAuth, signInWithCustomToken, signOut } from "firebase/auth";
import { useSelector } from "react-redux";
import { getDatabase, ref, off, onChildAdded, onChildChanged, onChildRemoved } from "firebase/database";

import {
    alertsSummary,
    } from "@/api/LoginSignup";


    

export const inititaliseFirebase = (fbConfig) => {

       const firebaseConfiguration = {
           apiKey: fbConfig?.apiKey,
           authDomain: fbConfig?.authDomain,
           projectId: fbConfig?.projectId,
            storageBucket: fbConfig?.storageBucket,
           messagingSenderId: fbConfig?.messagingSenderId,
           databaseURL: fbConfig?.databaseURL,
       };

       return !getApps().length ? initializeApp(firebaseConfiguration) : getApps()[0];
}
 

export const authenticateFirebase = (fbConfig) => {

   const firebaseConfiguration = {
           apiKey: fbConfig?.apiKey,
           authDomain: fbConfig?.authDomain,
           projectId: fbConfig?.projectId,
            storageBucket: fbConfig?.storageBucket,
           messagingSenderId: fbConfig?.messagingSenderId,
           databaseURL: fbConfig?.databaseURL,
       };
    const firebaseApp = !getApps().length ? initializeApp(firebaseConfiguration) : getApps()[0];

    alertsSummary().then((summary) => {
        
        const auth = getAuth();
        signInWithCustomToken(auth, summary?.data?.token)
            .then((userCredential) => {
                console.log('userCredential => ', userCredential)
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log('Firebase loggedin Failed ', errorMessage)
            });



    });

};

export const deattachListeners = (dbURL) => {
 
//    dbURL?.off();

}


export const firebaseSignout = () => {
    const auth = getAuth();
    if(auth){
        // const db = getDatabase();
        // const starCountRef = ref(db, '/buy/users/' + userID + '/summary');
        // deattachListeners(starCountRef);
        signOut(auth).then(() => {
            console.log('Sign-out successful')
            // Sign-out successful.
             })
    }
   
}

